import * as Types from './contentfulTypes';

import gql from 'graphql-tag';
import * as ApolloReactCommon from 'react-apollo';
export const AssetUrlFragmentDoc = gql`
    fragment AssetUrl on Asset {
  url
}
    `;
export const MarketingContentFieldsFragmentDoc = gql`
    fragment MarketingContentFields on MarketingContent {
  title
  description
  callToActionLabel
  callToActionLink
  visual {
    ...AssetUrl
    description
    width
    height
  }
  visualAlternativeText
}
    ${AssetUrlFragmentDoc}`;
export const GoalsValuePropsFieldsFragmentDoc = gql`
    fragment GoalsValuePropsFields on LoggedOutHomePageContent {
  goalsValuePropsTitle
  goalsValuePropOpen1
  goalsValuePropClose1
  goalsValuePropOpen2
  goalsValuePropClose2
  goalsValuePropOpen3
  goalsValuePropClose3
  goalsValuePropOpen4
  goalsValuePropClose4
}
    `;
export const ImageWithMetadataFieldsFragmentDoc = gql`
    fragment ImageWithMetadataFields on ImageWithMetadata {
  relationSlug
  image {
    url
  }
  imageAltText
}
    `;
export const C4BFieldsFragmentDoc = gql`
    fragment C4BFields on LoggedOutHomePageContent {
  c4BTitle
  c4BText
  c4BEnterpriseCtaText
  c4BPartnersLogosCollection {
    items {
      ...ImageWithMetadataFields
    }
  }
}
    ${ImageWithMetadataFieldsFragmentDoc}`;
export const TestimonialsFieldsFragmentDoc = gql`
    fragment TestimonialsFields on UniversityProgramTestimonial {
  authorName
  authorOrganization
  authorTitle
  image {
    url
  }
  text
}
    `;
export const ValuePropsFieldsFragmentDoc = gql`
    fragment ValuePropsFields on LoggedOutHomePageContent {
  valuePropsTitle
  valuePropTopQuality {
    ...MarketingContentFields
  }
  valuePropAccessible {
    ...MarketingContentFields
  }
  valuePropAppliedLearning {
    ...MarketingContentFields
  }
  valuePropCertificates {
    ...MarketingContentFields
  }
}
    ${MarketingContentFieldsFragmentDoc}`;
export const CarouselMetadataFieldsFragmentDoc = gql`
    fragment CarouselMetadataFields on LoggedOutHomePageCarouselMetadata {
  slug
  sectionTitle
  title
  subtitle
  cardFooterLabel
  callToActionLabel
  callToActionLink
}
    `;
export const MerchandisingHeroModuleFieldsFragmentDoc = gql`
    fragment MerchandisingHeroModuleFields on MerchandisingHeroModule {
  sys {
    id
  }
  region
  headline
  description
  shortDescription
  ctaText
  ctaTarget
  secondaryCtaText
  secondaryCtaTarget
  image {
    url
    description
  }
  imageTablet {
    url
    description
  }
  imageMobile {
    url
    description
  }
  backgroundColor
  eyebrowImage {
    url
    description
  }
}
    `;
export const LoggedOutHomePageContentFieldsFragmentDoc = gql`
    fragment LoggedOutHomePageContentFields on LoggedOutHomePageContent {
  regionSlug
  promoBannerId
  promoBannerText
  hero {
    ...MarketingContentFields
  }
  heroModuleBackgroundColor
  ...GoalsValuePropsFields
  outcomes {
    ...MarketingContentFields
  }
  outcomesC4BCtaText
  outcomesC4BCtaLink
  outcomesFootnote
  ...C4BFields
  partnerLogosTitle
  partnerLogosCollection {
    items {
      ...ImageWithMetadataFields
    }
  }
  testimonialsTitle
  testimonialsCollection {
    items {
      ...TestimonialsFields
    }
  }
  ...ValuePropsFields
  certificateCarouselMetadata {
    ...CarouselMetadataFields
  }
  degreeCarouselMetadata {
    ...CarouselMetadataFields
  }
  s18NCarouselMetadata {
    ...CarouselMetadataFields
  }
  coursesCarouselMetadata {
    ...CarouselMetadataFields
  }
  mastertrackCarouselMetadata {
    ...CarouselMetadataFields
  }
  universityCertificatesCarouselMetadata {
    ...CarouselMetadataFields
  }
  heroSectionPartnerLogosCollection {
    items {
      ...ImageWithMetadataFields
    }
  }
  carouselsMetadataCollection {
    items {
      ...CarouselMetadataFields
    }
  }
  regionalHeroModulesCollection {
    items {
      ...MerchandisingHeroModuleFields
    }
  }
}
    ${MarketingContentFieldsFragmentDoc}
${GoalsValuePropsFieldsFragmentDoc}
${C4BFieldsFragmentDoc}
${ImageWithMetadataFieldsFragmentDoc}
${TestimonialsFieldsFragmentDoc}
${ValuePropsFieldsFragmentDoc}
${CarouselMetadataFieldsFragmentDoc}
${MerchandisingHeroModuleFieldsFragmentDoc}`;
export const ImageFragmentDoc = gql`
    fragment Image on Asset {
  __typename
  width
  height
  url
  title
  description
  contentType
}
    `;
export const HeroBentoModuleFragmentDoc = gql`
    fragment HeroBentoModule on HeroBentoModule {
  __typename
  sys {
    id
  }
  cardsCollection {
    items {
      sys {
        id
      }
      backgroundColor
      ctaTarget
      ctaText
      description
      headline
      image {
        ...Image
      }
      mobileImage {
        ...Image
      }
      eyebrowImage {
        ...Image
      }
      eyebrowImageHeight
    }
  }
}
    ${ImageFragmentDoc}`;
export const CompactCollectionsModuleFragmentDoc = gql`
    fragment CompactCollectionsModule on CompactCollections {
  __typename
  sys {
    id
  }
  title
  collectionDataCollection {
    items {
      sys {
        id
      }
      title
      target
      collectionModuleId
      presetCollectionId
      collectionName
      collectionFacets
    }
  }
}
    `;
export const CareerAcademyModuleFragmentDoc = gql`
    fragment CareerAcademyModule on LohpCareerAcademyModule {
  __typename
  sys {
    id
  }
  title
  ctaLabel
}
    `;
export const DomainsModuleFragmentDoc = gql`
    fragment DomainsModule on LohpDomainModule {
  __typename
  sys {
    id
  }
  title
  target
}
    `;
export const OnboardingModuleFragmentDoc = gql`
    fragment OnboardingModule on LohpOnboardingModule {
  __typename
  sys {
    id
  }
}
    `;
export const PromoTemplatePartnerFragmentDoc = gql`
    fragment PromoTemplatePartner on PromoTemplatePartner {
  __typename
  sys {
    id
  }
  name
  logo {
    ...Image
  }
  target
}
    ${ImageFragmentDoc}`;
export const PromoTemplatePartnerListFragmentDoc = gql`
    fragment PromoTemplatePartnerList on PromoTemplatePartnerList {
  __typename
  sys {
    id
  }
  title
  partnersCollection(limit: 10) {
    items {
      ...PromoTemplatePartner
    }
  }
}
    ${PromoTemplatePartnerFragmentDoc}`;
export const PromoTemplateCollectionsFragmentDoc = gql`
    fragment PromoTemplateCollections on PromoTemplateCollections {
  __typename
  sys {
    id
  }
  backgroundColor
  gradientBackgroundColor
  headline
  description
  ctaText
  ctaTarget
  ctaVariant
  collectionSetsCollection {
    items {
      sys {
        id
      }
      context
      contextId
      collectionModuleId
      presetCollectionId
      filterName
    }
  }
}
    `;
export const PromoTemplateTestimonialFragmentDoc = gql`
    fragment PromoTemplateTestimonial on PromoTemplateTestimonial {
  __typename
  sys {
    id
  }
  author
  testimonial
  image {
    ...Image
  }
}
    ${ImageFragmentDoc}`;
export const PromoTemplateTestimonialCarouselFragmentDoc = gql`
    fragment PromoTemplateTestimonialCarousel on PromoTemplateTestimonialCarousel {
  __typename
  sys {
    id
  }
  headline
  backgroundColor
  testimonialsCollection {
    items {
      ...PromoTemplateTestimonial
    }
  }
}
    ${PromoTemplateTestimonialFragmentDoc}`;
export const PromoTemplateCannedCollectionFragmentDoc = gql`
    fragment PromoTemplateCannedCollection on PromoTemplateCannedCollection {
  __typename
  sys {
    id
  }
  heading
  subheading
  size
  color
  backgroundColor
  stickToPrevious
  showAllEntries
  showImageInFull
  cardsCollection {
    items {
      sys {
        id
      }
      headline
      body
      target
      ctaText
      cardBackgroundImage {
        ...Image
      }
      mobileCardBackgroundImage {
        ...Image
      }
      eyebrow
      eyebrowBackground
      eyebrowImage {
        ...Image
      }
      eyebrowImageHeight
      backgroundColor
    }
  }
}
    ${ImageFragmentDoc}`;
export const PromoTemplateFaqsFragmentDoc = gql`
    fragment PromoTemplateFaqs on PromoTemplateFaqs {
  __typename
  sys {
    id
  }
  headline
  faqsCollection {
    items {
      sys {
        id
      }
      question
      answer
    }
  }
}
    `;
export const FrontPageContentFragmentDoc = gql`
    fragment FrontPageContent on LohpPageContent {
  entryTitle
  modulesCollection {
    items {
      ...HeroBentoModule
      ...CompactCollectionsModule
      ...CareerAcademyModule
      ...DomainsModule
      ...OnboardingModule
      ...PromoTemplatePartnerList
      ...PromoTemplateCollections
      ...PromoTemplateTestimonialCarousel
      ...PromoTemplateCannedCollection
      ...PromoTemplateFaqs
    }
  }
}
    ${HeroBentoModuleFragmentDoc}
${CompactCollectionsModuleFragmentDoc}
${CareerAcademyModuleFragmentDoc}
${DomainsModuleFragmentDoc}
${OnboardingModuleFragmentDoc}
${PromoTemplatePartnerListFragmentDoc}
${PromoTemplateCollectionsFragmentDoc}
${PromoTemplateTestimonialCarouselFragmentDoc}
${PromoTemplateCannedCollectionFragmentDoc}
${PromoTemplateFaqsFragmentDoc}`;
export const GetLoggedOutHomePageContentDocument = gql`
    query getLoggedOutHomePageContent($regionSlug: String!, $preview: Boolean!, $isUsContent: Boolean!, $locale: String!) {
  regionalContent: loggedOutHomePageContentCollection(
    preview: $preview
    where: {regionSlug: $regionSlug}
    limit: 1
    locale: $locale
  ) @skip(if: $isUsContent) {
    items {
      ...LoggedOutHomePageContentFields
    }
  }
  usContent: loggedOutHomePageContentCollection(
    preview: $preview
    where: {regionSlug: "us"}
    limit: 1
    locale: $locale
  ) {
    items {
      ...LoggedOutHomePageContentFields
    }
  }
}
    ${LoggedOutHomePageContentFieldsFragmentDoc}`;
export type GetLoggedOutHomePageContentQueryResult = ApolloReactCommon.QueryResult<Types.GetLoggedOutHomePageContentQuery, Types.GetLoggedOutHomePageContentQueryVariables>;
export const FrontPageContentQueryDocument = gql`
    query FrontPageContentQuery($preview: Boolean!, $locale: String!) {
  lohpPageContentCollection(preview: $preview, limit: 1, locale: $locale) {
    items {
      ...FrontPageContent
    }
  }
}
    ${FrontPageContentFragmentDoc}`;
export type FrontPageContentQueryQueryResult = ApolloReactCommon.QueryResult<Types.FrontPageContentQueryQuery, Types.FrontPageContentQueryQueryVariables>;